module.exports = __webpack_public_path__ + "img/hs_title.19d0ee16.jpg";